import { Component, ViewEncapsulation, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW4801Model } from './kymw4801.model';
import { CrossCodeGet } from './vo/cross-code-get.model';
import { CrossGoodsInfoList } from './vo/cross-goods-info-list.model';
import { PcodeGoodsInfoList } from './vo/pcode-goods-info-list.model';
import { CrossGoodsDelete } from './vo/cross-goods-delete.model';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetCrossCodeService } from './api-services/get-cross-code.service';
import { GetCrossGoodsInfoListService } from './api-services/get-cross-goods-info-list.service';
import { GetPcodeGoodsInfoService } from './api-services/get-pcode-goods-info.service';
import { DeleteCrossSetServive } from './api-services/delete-cross-set.service';
import { RegistCrossSetServive } from './api-services/regist-cross-set.service';
import { UpdateCrossSetService } from './api-services/update-cross-set.service';
import { CheckUnselectedGoodsService } from './api-services/check-unselected-goods.service';
import { FlexGrid, CellType, CellRangeEventArgs, CellRange } from '@grapecity/wijmo.grid';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { PlessViewUtils } from 'src/app/shared/utils/pless-view-utils.service';
import { CrossGoodsRegist } from './vo/cross-goods-regist.model';
import { CrossGoodsUpdate } from './vo/cross-goods-update.model';

/**
 * クロス設定登録画面を管理するクラス
 *
 * @export KYMW4801Component
 * @class KYMW4801Component
 */
@Component({
  selector: 'app-kymw4801',
  templateUrl: 'kymw4801.component.html',
  styleUrls: ['kymw4801.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW4801Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  public kymw4801Model: KYMW4801Model = new KYMW4801Model();

  // 親画面からの連携値
  inputVo: CrossCodeGet;

  // 親画面への連携用
  setKYMW4801Parameter: Function;

  // 本画面更新用
  KYMW4801Component: Function;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;

  // 掲載順の最大値
  public maxPublishSeq: number = 0;
  // 編集有無フラグ
  private isEdited = false;
  // バイヤークロス商品設定一覧 選択した行インデックス
  public selectRowIndex: any = null;
  // コンテキストメニュー(右クリック)
  private contextMenu: Menu;
  private dragIndex: number;
  // 初期表示時クロスコード値
  public initialCrooCode: string
  // 初期表示時Pコード値
  public initialPCode: string
  //すでにクロス設定済みかのフラグ
  public isExsistCrossCodeflag: boolean = false;
  //親画面に渡すリスト
  public pcodeList = [];
  //チェックボックスのステータス
  public checkStatus: boolean;
  //Pコードを入力した行のindex
  focusedRowIndex: number | null = null;

  @ViewChild('dtg_CrossGoodsInfoList', { static: true }) dtg_CrossGoodsInfoList: FlexGrid;

  /**
   * Creates an instance of KYMW4801Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetCrossCodeService} getCrossCodeService
   * @param {GetCrossGoodsInfoListService} getCrossGoodsInfoListService
   * @param {GetPcodeGoodsInfoService} getPcodeGoodsInfoService
   * @param {DeleteCrossSetServive} deleteCrossSetServive
   * @param {registCrossSetServive} registCrossSetServive
   * @param {updateCrossSetService} updateCrossSetService
   * @param {CheckUnselectedGoodsService} checkUnselectedGoodsService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW4801Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private getCrossCodeService: GetCrossCodeService,
    private getCrossGoodsInfoListService: GetCrossGoodsInfoListService,
    private getPcodeGoodsInfoService: GetPcodeGoodsInfoService,
    private deleteCrossSetServive: DeleteCrossSetServive,
    private registCrossSetServive: RegistCrossSetServive,
    private updateCrossSetService: UpdateCrossSetService,
    private checkUnselectedGoodsService: CheckUnselectedGoodsService,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメータを受け取るためのメソッド
   *
   * @param {*} param 受け渡されるデータ
   * @memberof KYMW4801Component
   */
  public setInterfaceParam(param: CrossCodeGet): void {
    // 親画面のinputVOをそのまま受け取る
    this.inputVo = param;
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW4801Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW4801';
    this.kymw4801Model.kymw4801Component = this;
    this.createContextMenu();
    this.initialPCode = this.inputVo.pCode;

    this.dtg_CrossGoodsInfoList.rowHeaders.columns[0].minWidth = 5;

    // クロスコード取得処理
    this.getCrossCodeService.execute(this.kymw4801Model, this.inputVo, () => {
      // 初期表示に取得したクロスコードを格納する
      this.initialCrooCode = this.kymw4801Model.crossCode;

      // クロスコードがある場合、クロス商品情報一覧取得処理を呼び出す
      if (!PlessViewUtils.isEmpty(this.kymw4801Model.crossCode)) {
        // 初期表示用のAPIリクエスト
        const vo: CrossGoodsInfoList = new CrossGoodsInfoList();
        vo.orderCode = this.inputVo.orderCode;
        vo.crossCode = this.kymw4801Model.crossCode;
        vo.mediumType = this.inputVo.mediumType;

        this.getCrossGoodsInfoListService.execute(this.kymw4801Model, vo, () => {
          if (this.kymw4801Model.crossGoodsInfoList.length > 0) {
            // グリッドの更新
            this.dtg_CrossGoodsInfoList.collectionView.refresh();
          }
        });
      } else {
        // クロスコードがない場合、Pコード商品取得処理を呼び出す
        // 初期表示用のAPIリクエスト
        const vo: PcodeGoodsInfoList = new PcodeGoodsInfoList();
        vo.pCode = this.initialPCode;

        this.getPcodeGoodsInfoService.execute(this.kymw4801Model, vo, () => {
          this.kymw4801Model.crossGoodsInfoList = this.kymw4801Model.pcodeGoodsInfoList;
          // 一覧の最下行に新規行を追加する
          const newRow = {
            PublishSeq: this.kymw4801Model.crossGoodsInfoList.length + 1,
            PCode: '', GuideGoodsName: '',
            GuideStandardName: '',
            ChildKomaSettings: 0
          };
          const newDataSource = [...this.kymw4801Model.crossGoodsInfoList, newRow];
          // 更新されたデータソースを設定
          this.kymw4801Model.crossGoodsInfoList = newDataSource;
          // グリッドの更新
          this.dtg_CrossGoodsInfoList.collectionView.refresh();
        });
      }
    }, null);

    // チェックボックスのセルクリックでチェックボックスON/OFF可能とする
    this.dtg_CrossGoodsInfoList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      if ( (e.target as HTMLInputElement).type !== "checkbox") {
        const ht = this.dtg_CrossGoodsInfoList.hitTest(e);
        if (0 <= ht.row && (ht.col === 4)) {
          if ( !ht.target.className.includes('wj-header') && !ht.target.className.includes('ng-valid') ) {
            document.getElementById(`ChildKomaSettings_${ht.row}`).click();
          }
        }
      }
    });
  }

  /**
   * コンテキストメニュー作成
   *
   * @memberof KYMW4801Component
   */
  private createContextMenu(): void {
    this.contextMenu = new Menu(document.createElement('div'), {
      displayMemberPath: 'caption',
      selectedValuePath: 'cmd',
      itemsSource: [
        { caption: '行追加', cmd: 'add', enabled: true },
        { caption: '行削除', cmd: 'delete', enabled: true },
      ],
      command: {
        canExecuteCommand: param => {
          return param.enabled === false ? false : true;
        },
      },
      itemClicked: () => {
        switch (this.contextMenu.selectedValue) {
          case 'add':
            this.addClickHandler();
            break;
          case 'delete':
            this.deleteClickHandler();
        }
      },
    });
    this.dtg_CrossGoodsInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        this.contextMenuSelectHandler(e);
        // メニュー表示
        this.contextMenu.show(e);
      }
    });
  }

  /**
   * コンテキストメニュー 選択
   *
   * @memberof KYMW7200Component
   */
  private contextMenuSelectHandler(e: any): void {
    const ht = this.dtg_CrossGoodsInfoList.hitTest(e.pageX, e.pageY);

    // 選択した行がすでに選択されていない行の場合はその行を選択（既に選択されている行はクリア）
    const alreadySelectedRow = this.dtg_CrossGoodsInfoList.selectedRows.filter(row => row.index === ht.row);
    if (PlessViewUtilsSub.isEmptyArray(alreadySelectedRow)) {
      // 右クリック押下時に対象行を選択状態にする
      const grid = new CellRange(ht.row, ht.col);
      this.dtg_CrossGoodsInfoList.select(grid, false);
    }
    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = true;
    // グリッドのセル外または選択行がない場合はコンテキストメニューを非活性
    if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dtg_CrossGoodsInfoList.selectedRows))) {
      contextMenuEnabledMode = false;
      this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
        item.enabled = contextMenuEnabledMode;
      });
    } else {
      // 選択している行の情報を取得
      const selectedRowIndex = this.dtg_CrossGoodsInfoList.selection.row;
      const selectedRowData = this.dtg_CrossGoodsInfoList.itemsSource[selectedRowIndex];

      if (selectedRowData.PCode === this.initialPCode) {
        // 対象のPコード（遷移元で右クリックした商品）の場合行削除の項目を非表示
        this.contextMenu.itemsSource = this.contextMenu.itemsSource.filter(item => item.cmd !== 'delete');
      } else {
        this.contextMenu.itemsSource = [
          { caption: '行追加', cmd: 'add', enabled: true },
          { caption: '行削除', cmd: 'delete', enabled: true }
        ],
        this.contextMenu.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
          item.enabled = contextMenuEnabledMode;
        });
      }
    }
  }

  /**
   * コンテキストメニュー 行追加
   *
   * @memberof KYMW4801Component
   */
  private addClickHandler() {
    // 選択された行のインデックスを取得
    const selectedRowIndex = this.dtg_CrossGoodsInfoList.selection.row;
    // 新規行作成
    const newRow = {
      PublishSeq: '',
      PCode: '', GuideGoodsName: '',
      GuideStandardName: '',
      ChildKomaSettings: 0
    };

    // 選択された次の行に新規行を追加
    this.dtg_CrossGoodsInfoList.itemsSource.splice(selectedRowIndex + 1, 0, newRow);

    // 新しい行を含む以降の行の掲載順を更新
    for (let i = selectedRowIndex + 1; i < this.dtg_CrossGoodsInfoList.itemsSource.length; i++) {
      this.dtg_CrossGoodsInfoList.itemsSource[i].PublishSeq = i + 1;
    }
    // グリッドをリフレッシュして変更を反映
    this.dtg_CrossGoodsInfoList.collectionView.refresh();
  }

  /**
   * コンテキストメニュー 行削除
   *
   * @memberof KYMW4801Component
   */
  private deleteClickHandler() {
    // 選択している行の情報を取得
    const selectedRowIndex = this.dtg_CrossGoodsInfoList.selection.row;
    const selectedRowData = this.dtg_CrossGoodsInfoList.itemsSource[selectedRowIndex];

    if (selectedRowData.PCode !== this.initialPCode) {
      // 削除に伴い掲載順を更新
      for (let i = selectedRowIndex + 1; i < this.dtg_CrossGoodsInfoList.itemsSource.length; i++) {
        this.dtg_CrossGoodsInfoList.itemsSource[i].PublishSeq = i;
      }
      // 削除対象のマルチコードを検索し、マルチコード一覧から削除
      this.dtg_CrossGoodsInfoList.itemsSource.splice(selectedRowIndex, 1);
      this.isEdited = true;
      // グリッドの更新
      this.dtg_CrossGoodsInfoList.collectionView.refresh();
    }
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW4801Component
   */
  public ngAfterViewInit(): void {
  }

  /**
   * Pコード重複判定
   *
   * @memberof KYMW4801Component
   */
  public getPcodeMatch(index: number, pcode: string) {
    // 元画面のPコードと同じPコードの入力欄をラベル(編集不可)に変更する
    if (this.initialPCode === pcode) {
      return true;
    }
  }

  /**
   * 子コマ配置チェンジイベント
   *
   * @memberof KYMW4801Component
   */
  public eventChildKomaSettings_CHANGEHandler(event: MouseEvent) {
    // 選択している行の情報を取得
    const selectedRowIndex = this.dtg_CrossGoodsInfoList.selection.row;
    const selectedRowData = this.dtg_CrossGoodsInfoList.itemsSource[selectedRowIndex];
    this.checkStatus = event.target['checked'];
    if (this.checkStatus) {
      selectedRowData.ChildKomaSettings = 1;
      this.isEdited = true;
    } else {
      selectedRowData.ChildKomaSettings = 0;
      this.isEdited = true;
    }
  }

  /**
   * Pコードテキストボックスフォーカスインイベント
   * Pコードを入力した行のindexを取得
   * @param event フォーカスインイベント
   */
  public eventTxt_Pcode_FOCUS_INHandler() {
    const grid: FlexGrid = this.dtg_CrossGoodsInfoList;
    const rowIndex = grid.selection.row;
    this.focusedRowIndex = rowIndex;
  }

  /**
   * Pコードテキストボックスフォーカスアウトイベント
   *
   * @param event フォーカスアウトイベント
   */
  public eventTxt_Pcode_FOCUS_OUTHandler(event: Event): void {
    const vo: PcodeGoodsInfoList = new PcodeGoodsInfoList();
    // 入力されたPコード取得
    const target = event.target as HTMLInputElement;
    vo.pCode = target.value;
    const rowIndex = this.focusedRowIndex;

    // 入力された値がない（クリア）場合
    if (PlessViewUtils.isEmpty(vo.pCode)) {
      this.isEdited = true;
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideGoodsName = '';
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideStandardName = '';
      // グリッドをリフレッシュして変更を反映
      this.dtg_CrossGoodsInfoList.collectionView.refresh();

    } else if (vo.pCode === this.initialPCode || !PlessViewUtilsSub.PCODE_REGEX.test(vo.pCode)) {
      // Pコードが無効です。
      this.dialogService.openAlertGetMessage('E0585', null)
      // 該当行の各列の値をクリア
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].PCode = '';
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideGoodsName = '';
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideStandardName = '';
      this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].ChildKomaSettings = 0;
      // グリッドをリフレッシュして変更を反映
      this.dtg_CrossGoodsInfoList.collectionView.refresh();

    } else {
      // Pコード重複チェック
      // 先頭行（this.initialPCode）はチェック済みのため不要
      // 追加行（rowIndex、選択行）は入力しようとしている値のためチェック対象に含めない
      const pCodeList = [];
      for (let i = 1; i < this.dtg_CrossGoodsInfoList.itemsSource.length; i++) {
        if (i !== rowIndex) {
          pCodeList.push(this.dtg_CrossGoodsInfoList.itemsSource[i].PCode);
        }
      }
      if (pCodeList.includes(vo.pCode)) {
        // Pコードが無効です。
        this.dialogService.openAlertGetMessage('E0585', null)
        // 該当行の各列の値をクリア
        this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].PCode = '';
        this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideGoodsName = '';
        this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideStandardName = '';
        this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].ChildKomaSettings = 0;
        // グリッドをリフレッシュして変更を反映
        this.dtg_CrossGoodsInfoList.collectionView.refresh();
      } else {
        this.getPcodeGoodsInfoService.execute(this.kymw4801Model, vo, () => {
        if (!PlessViewUtils.isEmpty(this.kymw4801Model.pcodeGoodsInfoList[0])) {
          this.isEdited = true;
          // 一覧の該当行に表示する
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideGoodsName = this.kymw4801Model.pcodeGoodsInfoList[0].GuideGoodsName;
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideStandardName = this.kymw4801Model.pcodeGoodsInfoList[0].GuideStandardName;
          // グリッドをリフレッシュして変更を反映
          this.dtg_CrossGoodsInfoList.collectionView.refresh();
        } else {
          //Pコードが無効です。
          this.dialogService.openAlertGetMessage('E0585', null)
          // 該当行の各列の値をクリア
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].PCode = '';
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideGoodsName = '';
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].GuideStandardName = '';
          this.dtg_CrossGoodsInfoList.itemsSource[rowIndex].ChildKomaSettings = 0;
          // グリッドをリフレッシュして変更を反映
          this.dtg_CrossGoodsInfoList.collectionView.refresh();
        }
      });
      }
    }
    // フォーカスアウト後、初期化
    this.focusedRowIndex = null;
  }

  /**
   * 行追加ボタン押下イベント
   * 
   * @param contextMenuEvent イベント
   */
  public eventRowAdd_CLICKHandler(): void {
    // 新規行作成
    const newRow = {
      PublishSeq: this.dtg_CrossGoodsInfoList.itemsSource.length + 1,
      PCode: '', GuideGoodsName: '',
      GuideStandardName: '',
      ChildKomaSettings: 0
    };
    const newDataSource = [...this.dtg_CrossGoodsInfoList.itemsSource, newRow];
    this.dtg_CrossGoodsInfoList.itemsSource = newDataSource;
    // グリッドをリフレッシュして変更を反映
    this.dtg_CrossGoodsInfoList.collectionView.refresh();
  }

  /**
   * 全行削除ボタンクリックイベント
   *
   * @memberof KYMW4801Component
   */
  public eventRowDelete_CLICKHandler(): void {
    this.dialogService.openAlertGetMessage('Q0189', null,
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          // クロス商品一覧の行企画回別商品一覧画面で右クリックした商品(選択した商品)の行を特定する条件
          const pCodeToKeep = this.initialPCode;
          // 現在のデータソースを取得
          const currentDataSource = this.dtg_CrossGoodsInfoList.itemsSource as any[];
          // 指定されたPcodeと一致する行をフィルタリング
          const filteredRows = currentDataSource.filter(item => item.PCode === pCodeToKeep);
          // 一覧の最下行に新規行を追加する
          const newRow = {
            PublishSeq: filteredRows.length + 1,
            PCode: '', GuideGoodsName: '',
            GuideStandardName: '',
            ChildKomaSettings: 0
          };
          const newDataSource = [...filteredRows, newRow];
          // 更新されたデータソースを設定
          this.dtg_CrossGoodsInfoList.itemsSource = newDataSource;
          // 掲載順を1に設定
          this.dtg_CrossGoodsInfoList.itemsSource[0].PublishSeq = 1;
          // グリッドをリフレッシュして変更を反映
          this.dtg_CrossGoodsInfoList.collectionView.refresh();
          this.isEdited = true;
        }
      }
    );
  }

  /**
   * マーク 一覧 行ドラッグ
   *
   * @memberof KYMW4801Component
   */
  public onDraggingRow(s: FlexGrid, e: CellRangeEventArgs) {
    this.dragIndex = e.row;
    s.collectionView.moveCurrentToPosition(this.dragIndex);
  }

  /**
   * マーク 一覧 行ドロップ
   *
   * @memberof KYMW4801Component
   */
  public onDraggedRow(s: FlexGrid, e: CellRangeEventArgs): void {

    // this.changeFlag = true;
    const dropIndex = e.row;

    // 掲載順を入れ替え
    const temp = this.dtg_CrossGoodsInfoList.rows[this.dragIndex].dataItem;
    this.dtg_CrossGoodsInfoList.rows[this.dragIndex].dataItem = this.dtg_CrossGoodsInfoList.rows[dropIndex].dataItem;
    this.dtg_CrossGoodsInfoList.rows[dropIndex].dataItem = temp;

    const arr = s.collectionView.sourceCollection;
    s.collectionView.deferUpdate(() => {
      let item = arr[this.dragIndex];
      arr.splice(this.dragIndex, 1);
      arr.splice(dropIndex, 0, item);
      s.collectionView.moveCurrentToPosition(dropIndex);
    });

    // 掲載順を更新
    for (let i = 0; i < this.dtg_CrossGoodsInfoList.itemsSource.length; i++) {
      this.dtg_CrossGoodsInfoList.itemsSource[i].PublishSeq = i + 1;
    }
    // グリッドをリフレッシュして変更を反映
    this.dtg_CrossGoodsInfoList.collectionView.refresh();
    this.isEdited = true;
  }

  /**
   * 設定ボタンクリックイベント
   *
   * @memberof KYMW4801Component
   */
  public async eventSetBtn_CLICKHandler(): Promise<void> {
    // 空行のカウント
    let isEmptyRowCount = 0;
    const grid: FlexGrid = this.dtg_CrossGoodsInfoList;

    grid.rows.forEach(row => {
      if (PlessViewUtils.isEmpty(row.dataItem.PCode)) {
        // 空行の数をカウント
        isEmptyRowCount++;
      } else {
        this.pcodeList.push(row.dataItem.PCode)
      }
    });

    // クロス商品が2件未満の場合
    if (this.dtg_CrossGoodsInfoList.itemsSource.length - isEmptyRowCount < 2) {
      // 初期表示処理時に取得したクロスコード値がnullの場合
      if (this.kymw4801Model.crossCode === null) {
        this.exit();
      } else {
        const vo: CrossGoodsDelete = new CrossGoodsDelete();
        vo.orderCode = this.inputVo.orderCode;
        vo.crossCode = this.kymw4801Model.crossCode;
        vo.mediumType = this.inputVo.mediumType;

        //クロス設定削除処理
        this.deleteCrossSetServive.execute(vo, () => {
          //親画面の値を渡す
          this.setKYMW4801Parameter(this.pcodeList);
          // 画面を閉じる
          this.exit();
        });
      }
    } else {
      // 未選定商品が含まれているか
      let hasUnselectedGoods = false;
      // すでにクロス設定済みか
      this.isExsistCrossCodeflag = false;

      // 一覧全件分妥当性チェックを行う
      for (let i = 0; i < this.dtg_CrossGoodsInfoList.itemsSource.length && !this.isExsistCrossCodeflag; i++) {
        if (PlessViewUtils.isEmpty(this.dtg_CrossGoodsInfoList.itemsSource[i].PCode)) {
          continue;
        }
        this.inputVo.pCode = this.dtg_CrossGoodsInfoList.itemsSource[i].PCode;
        // 非同期ループ内では break できないので, async/await で一件ずつチェックする
        await new Promise<void>(async (resolve, reject) => {
          this.getCrossCodeService.execute(this.kymw4801Model, this.inputVo, async () => {
            // 商品未選定チェックを行う
            this.checkUnselectedGoodsService.execute(this.kymw4801Model, this.inputVo, async (data) => {
              // チェック結果が "1" (未選定) の場合, エラーとする
              if (data.CheckResult === '1') {
                hasUnselectedGoods = true;
              }
              resolve();
            });
          }, null);
        });

        // 未選定商品が含まれていたらループ処理終了
        if (hasUnselectedGoods) {
          // エラーメッセージ「同一企画回・媒体で選定されていない商品が含まれています。」
          this.dialogService.openAlertGetMessage('E0602');
          break;
        } else {
          this.isCheckCrossCode();
        }
      }

      // 未選定商品が含まれていたら設定処理を強制終了
      if (hasUnselectedGoods) {
        return;
      }
      // すでにクロス設定済みの場合は設定処理を強制終了
      if (this.isExsistCrossCodeflag) {
        return;
      }

      if (PlessViewUtils.isEmpty(this.initialCrooCode)) {
        // 初期表示に取得したクロスコードがない場合は登録
        this.registCrossSet();
      } else {
        // 初期表示に取得したクロスコードがある場合は更新
        this.updateCrossSet();
      }
    }
  }

  /**
   * クロスコードによってエラーか判定する処理
   *
   * @memberof KYMW4801Component
   */
  public isCheckCrossCode(): void {
    // 初期表示に取得したクロスコードがない かつ 設定ボタン押下時に取得したクロスコードがある
    if (PlessViewUtils.isEmpty(this.initialCrooCode) && !PlessViewUtils.isEmpty(this.kymw4801Model.crossCode)) {
      this.isExsistCrossCodeflag = true;
      // すでにクロス設定済みのメッセージ表示
      this.dialogService.openAlertGetMessage('E0589')
    } else {
      if (!PlessViewUtils.isEmpty(this.kymw4801Model.crossCode) && this.kymw4801Model.crossCode !== this.initialCrooCode) {
        this.isExsistCrossCodeflag = true;
        // すでにクロス設定済みのメッセージ表示
        this.dialogService.openAlertGetMessage('E0589')
      }
    }
  }

  /**
   * クロス設定登録処理
   *
   * @memberof KYMW4801Component
   */
  public registCrossSet(): void {
    const vo: CrossGoodsRegist = new CrossGoodsRegist();
    const grid: FlexGrid = this.dtg_CrossGoodsInfoList;

    // 新しい掲載順
    let newPublishSeq = 1;
    vo.orderCode = this.inputVo.orderCode;
    vo.mediumType = this.inputVo.mediumType;

    grid.rows.forEach(row => {
      if (!PlessViewUtils.isEmpty(row.dataItem.PCode)) {
        // 空行がある場合掲載順を詰める
        row.dataItem.PublishSeq = newPublishSeq++;
        const crossGoodsItem = {
          PCode: row.dataItem.PCode,
          ChildKomaSettings: parseInt(row.dataItem.ChildKomaSettings),
          PublishSeq: row.dataItem.PublishSeq,
          FormDispFlag: 0
        };
        vo.crossGoods.push(crossGoodsItem);
      }
    });
    this.registCrossSetServive.execute(vo, () => {
      // 親画面の値を渡す
      this.setKYMW4801Parameter(this.pcodeList);
      // 画面を閉じる
      this.exit();
    });
  }

  /**
   * クロス設定更新処理
   *
   * @memberof KYMW4801Component
   */
  public updateCrossSet(): void {
    const vo: CrossGoodsUpdate = new CrossGoodsUpdate();
    const grid: FlexGrid = this.dtg_CrossGoodsInfoList;

    // 新しい掲載順
    let newPublishSeq = 1;
    vo.orderCode = this.inputVo.orderCode;
    vo.crossCode = this.initialCrooCode
    vo.mediumType = this.inputVo.mediumType;
    grid.rows.forEach(row => {
      if (!PlessViewUtils.isEmpty(row.dataItem.PCode)) {
        // 空行がある場合掲載順を詰める
        row.dataItem.PublishSeq = newPublishSeq++;
        const crossGoodsItem = {
          PCode: row.dataItem.PCode,
          ChildKomaSettings: parseInt(row.dataItem.ChildKomaSettings),
          PublishSeq: row.dataItem.PublishSeq,
          FormDispFlag: 0
        };
        vo.crossGoods.push(crossGoodsItem);
      }
    });
    this.updateCrossSetService.execute(vo, () => {
      // 親画面の値を渡す
      this.setKYMW4801Parameter(this.pcodeList);
      // 画面を閉じる
      this.exit();
    });
  }

  /**
   * 閉じるボタンクリックイベント
   *
   * @memberof KYMW4801Component
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.isEdited) {
      this.dialogService.openAlertGetMessage('Q0110', null,
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            // 画面を閉じる
            this.exit();
          }
        }
      );
    } else {
      // 画面を閉じる
      this.exit();
    }
  }

  /**
   * 画面終了
   *
   * @memberof KYMW4801Component
   */
  public exit(): void {
    // 画面を閉じる
    this.isEdited = false;
    super.onClickClose();
  }
}
